// extracted by mini-css-extract-plugin
export default {"container":"GeneralWarning-module__container--U-C1D"};